export * from './IconSelectPaper'
